// extracted by css-extract-rspack-plugin
export default {"chevron":"genesis__chevron____nHzt"};